import { render, staticRenderFns } from "./RealSituation.vue?vue&type=template&id=9406ad5e&scoped=true&"
import script from "./RealSituation.vue?vue&type=script&lang=js&"
export * from "./RealSituation.vue?vue&type=script&lang=js&"
import style0 from "./RealSituation.vue?vue&type=style&index=0&id=9406ad5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9406ad5e",
  null
  
)

export default component.exports